import { type PropsWithChildren } from 'react';

import styles from '@web/templates/ErrorPages/molecules/ErrorText/ErrorText.module.scss';
import { replaceNewLine } from '@web/utils/replaceNewLine';

interface ErrorTextContent {
    errorCode: number;
    description: string;
    subtitle: string;
    staticImageUrl?: string;
}

interface Props extends PropsWithChildren {
    content: ErrorTextContent;
}

export const ErrorText = ({ content: { errorCode, description, subtitle } }: Props) => {
    return (
        <div className={styles.ErrorText}>
            <h3>{subtitle}</h3>
            <h1>{errorCode}</h1>
            <p>{replaceNewLine(description)}</p>
        </div>
    );
};
